<script setup lang="ts">
//vue
import { reactive, onMounted } from "vue";

//services
import * as empresaService from "@/services/empresaService";

import { f2dec, fdata, fdataHora } from "@/utils/funcoes";
import imgLogin from "@/assets/images/logoLogin.png";

import Parcela from "../cliente/Parcela.vue";
import MsgBox from "@/components/MsgBox/Index.vue";

const controle = reactive({
    dadosEmpresa: null as empresaService.DadosEmpresa | null,
    parceiros: [] as import("@/services/clienteService").Parceiro[],
    filtrosParceiros: {
        pesquisa: "",
        categoriaId: null as number | null,
        cidadeId: null as number | null,
        paginaAtual: 1,
        tamanhoPagina: 12
    } as empresaService.EmpresaParceirosFiltros,
    totalParceiros: 0,
    cidades: [] as import("@/services/clienteService").Cidade[],
    ver: "" as string,
    status: "" as string,
    erro: "" as string,
    janSair: false as boolean
});

onMounted(() => {
    buscarDadosEmpresa();
    buscarParceiros();
    buscarCidades();
});

function buscarDadosEmpresa() {
    controle.status = "Buscando dados da empresa...";
    empresaService.obterDados()
        .then((r) => {
            controle.status = "";
            controle.dadosEmpresa = r;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarParceiros() {
    controle.status = "Buscando parceiros...";

    if (controle.filtrosParceiros.cidadeId != null) {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 300;
    }
    else {
        controle.filtrosParceiros.paginaAtual = 1;
        controle.filtrosParceiros.tamanhoPagina = 16;
    }
    empresaService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function verTodosParceiros() {
    controle.filtrosParceiros.pesquisa = "";
    controle.filtrosParceiros.categoriaId = null;
    controle.filtrosParceiros.cidadeId = null;
    controle.filtrosParceiros.paginaAtual = 1;
    controle.filtrosParceiros.tamanhoPagina = 300;

    controle.status = "Buscando parceiros...";
    empresaService.obterParceiros(controle.filtrosParceiros)
        .then((r) => {
            controle.status = "";
            controle.parceiros = r.dados;
            controle.totalParceiros = r.totalRegistros;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function buscarCidades() {
    controle.status = "Buscando cidades...";
    empresaService.obterCidades()
        .then((r) => {
            controle.status = "";
            controle.cidades = r;
        })
        .catch((error) => {
            controle.status = "";
            controle.erro = error.message || "Erro desconhecido";
        });
}

function pergSair() {
    controle.janSair = true;
}

function sair() {
    controle.janSair = false;
    controle.status = "Saindo...";
    localStorage.removeItem("empresaUser");
    window.location.reload();
}

</script>

<template>
    <div class="row mt-4">
        <div class="col-md-12 text-center">
            <img :src="imgLogin" alt="Logo" class="img-fluid img-logo mb-3" />
        </div>
    </div>

    <div class="row mt-2 mb-2">
        <div class="col-md-12">
            <h3 class="mb-0">Área da Empresa</h3>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            Bem-vindo, {{ controle.dadosEmpresa ? controle.dadosEmpresa.empresa.nome : 'Empresa' }}!
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <h4 v-if="controle.erro == ''">{{ controle.status }}</h4>
            <h4 v-if="controle.erro != ''" class="text-danger">{{ controle.erro }}</h4>
        </div>
    </div>

    <div class="row" id="divHome" v-if="controle.ver == ''">
        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusDados'">
                <div class="titulo">Meu Cadastro</div>
                <i class="flaticon-user-3"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'funcionarios'">
                <div class="titulo">Funcionários</div>
                <i class="flaticon-people"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusBoletos'">
                <div class="titulo">Meus Boletos</div>
                <i class="flaticon-document"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="controle.ver = 'meusContratos'">
                <div class="titulo">Meus Contratos</div>
                <i class="flaticon-document"></i>
            </a>
        </div>

        <div class="col-md-2 col-6">
            <RouterLink class="botao-menu" :to="{ name: 'EmpresaAlterarSenha' }">
                <div class="titulo">Alterar Senha</div>
                <i class="flaticon-lock"></i>
            </RouterLink>
        </div>

        <div class="col-md-2 col-6">
            <a class="botao-menu" @click="pergSair()">
                <div class="titulo">Sair</div>
                <i class="flaticon-right-arrow-1"></i>
            </a>
        </div>
    </div>

    <div class="row" id="divMeusDados" v-if="controle.ver == 'meusDados'">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Dados da Empresa</h5>

                    <div class="col-md-12 dados-empresa">
                        <div> Nome: {{ controle.dadosEmpresa?.empresa.nome }}</div>
                        <div> CNPJ: {{ controle.dadosEmpresa?.empresa.cnpj }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.responsavel"> Responsável: {{ controle.dadosEmpresa?.empresa.responsavel }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.ie"> Inscrição Estadual: {{ controle.dadosEmpresa?.empresa.ie }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.im"> Inscrição Municipal: {{ controle.dadosEmpresa?.empresa.im }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.email"> Email: {{ controle.dadosEmpresa?.empresa.email }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.telefone"> Telefone: {{ controle.dadosEmpresa?.empresa.telefone }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.celular"> Celular: {{ controle.dadosEmpresa?.empresa.celular }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.logradouro"> Logradouro: {{ controle.dadosEmpresa?.empresa.logradouro }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.numero"> Número: {{ controle.dadosEmpresa?.empresa.numero }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.bairro"> Bairro: {{ controle.dadosEmpresa?.empresa.bairro }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.complemento"> Complemento: {{ controle.dadosEmpresa?.empresa.complemento }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.cidade"> Cidade: {{ controle.dadosEmpresa?.empresa.cidade?.nome }} - {{ controle.dadosEmpresa?.empresa.cidade?.estado }}</div>
                        <div v-if="controle.dadosEmpresa?.empresa.cep"> CEP: {{ controle.dadosEmpresa?.empresa.cep }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12 mt-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divFuncionarios" v-if="controle.ver == 'funcionarios'">
        <div class="col-md-12">
            <h3>Funcionários</h3>
        </div>
        <div class="col-md-12" v-for="funcionario in controle.dadosEmpresa?.funcionarios" :key="funcionario.clienteId">
            <div class="card mb-2">
                <div class="card-body">
                    <h5 class="card-title">{{ funcionario.nome }}</h5>
                    <div class="row">
                        <div class="col-md-3 col-6">CPF: {{ funcionario.cpf }}</div>
                        <div class="col-md-3 col-6">Nascimento: {{ fdata(funcionario.dataNascimento) }}</div>
                        <div class="col-md-3 col-6">Plano: {{ funcionario.planoNome }}</div>
                        <div class="col-md-3 col-6">Valor R$: {{ f2dec(funcionario.valor) }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12" v-if="!controle.dadosEmpresa?.funcionarios || controle.dadosEmpresa?.funcionarios.length == 0">
            Nenhum funcionário vinculado.
        </div>
        <div class="col-md-12 mt-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divMeusContratos" v-if="controle.ver == 'meusContratos'">
        <div class="col-md-12">
            <h3>Meus Contratos</h3>
        </div>

        <div class="col-md-12" v-for="contrato in controle.dadosEmpresa?.contratos" :key="contrato.contratoId">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <h5 class="card-title">Contrato: {{ contrato.contratoId }} </h5>
                        </div>
                        <div class="col-md-4">
                            <h5 class="card-title">Plano: {{ contrato.plano.nome }}</h5>
                        </div>
                        <div class="col-md-4">
                            <h5 class="card-title">
                                <span class="badge rounded-pill" :class="contrato.statusId === 2 ? 'badge-soft-success' : 'badge-soft-warning'">
                                    {{ contrato.status.descricao }}
                                </span>
                            </h5>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-6">
                            Inicio: {{ fdata(contrato.dataInicio) }}
                        </div>
                        <div class="col-md-4 col-6">
                            Fim: {{ fdata(contrato.dataFim) }}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            Assinado em: {{ fdataHora(contrato.dataAssinatura) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-12" v-if="!controle.dadosEmpresa?.contratos || controle.dadosEmpresa?.contratos.length == 0">
            Nenhum contrato encontrado.
        </div>
        <div class="col-md-12 mt-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row" id="divMeusBoletos" v-if="controle.ver == 'meusBoletos'">
        <div class="col-md-12">
            <h3>Meus Boletos</h3>
        </div>

        <div class="col-md-12 mt-2">
            <h3 class="">A Pagar</h3>
        </div>
        <div class="col-md-12" v-for="parcela in controle.dadosEmpresa?.mensalidades.filter(a=> a.dataPagamento == null)" :key="parcela.mensalidadeId">
            <Parcela :parcela="parcela" />
        </div>

        <div class="col-md-12 mt-2">
            <h3>Pagas</h3>
        </div>
        <div class="col-md-12" v-for="parcela in controle.dadosEmpresa?.mensalidades?.filter(a=> a.dataPagamento != null)" :key="parcela.mensalidadeId">
            <Parcela :parcela="parcela" />
        </div>

        <div class="col-md-12 mt-3 mb-3 d-grid gap-2 d-sm-block">
            <button class="btn btn-secondary" @click="controle.ver = ''">Voltar</button>
        </div>
    </div>

    <div class="row mt-2 mb-2" id="divParceiros" v-if="controle.ver == ''">
        <div class="col-md-12 mb-2">
            <h3>Parceiros</h3>
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-search"></i> Pesquisar </label>
            <input class="form-control form-control-sm" v-model="controle.filtrosParceiros.pesquisa"
                @input="buscarParceiros()" placeholder="Nome do parceiro">
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-search"></i> Categoria </label>
            <select class="form-select form-select-sm" v-model="controle.filtrosParceiros.categoriaId"
                @change="buscarParceiros()">
                <option :value="null">- Todas Categorias - </option>
                <option v-for="categoria in controle.dadosEmpresa?.categorias" :key="categoria.categoriaId"
                    :value="categoria.categoriaId">
                    {{ categoria.descricao }}
                </option>
            </select>
        </div>

        <div class="col-md-3 mb-2">
            <label><i class="flaticon-marker"></i> Cidade </label>
            <select class="form-select form-select-sm" v-model="controle.filtrosParceiros.cidadeId"
                @change="buscarParceiros()">
                <option :value="null">- Todas Cidades - </option>
                <option v-for="cidade in controle.cidades" :key="cidade.cidadeId" :value="cidade.cidadeId">
                    {{ cidade.nome }} - {{ cidade.estado }}
                </option>
            </select>
        </div>

        <div class="col-md-3">
            <a class="btn btn-primary btn-sm mb-2 mt-4" href="javascript:void(0);" @click="verTodosParceiros()">
                Ver todos
            </a>
        </div>

        <div class="col-md-3" v-for="parceiro in controle.parceiros" :key="parceiro.parceiroId">
            <div class="card mb-4">
                <img :src="`${parceiro.arquivo}`" class="card-img-top" alt="...">
                <div class="card-body">
                    <h6 class="card-title fw-bold">{{ parceiro.nome }}</h6>
                    <div class="card-text endereco mb-0"> {{ parceiro.logradouro != null ? parceiro.logradouro + ' ' +
                        parceiro.numero + ' - ' : '' }} {{ parceiro.bairro }} </div>
                    <div class="card-text cidade mb-0">{{ parceiro.cidade?.nome }}/{{ parceiro.cidade?.estado }}</div>
                    <div class="card-text desconto mb-0 fw-bold"
                        v-if="parceiro.valorDescontoIni != null && parceiro.valorDescontoIni > 0">
                        Desconto: de {{ parceiro.valorDescontoIni }} % até {{ f2dec(parceiro.valorDesconto) }} %
                    </div>
                    <div class="card-text desconto mb-0 fw-bold mt-3"
                        v-if="parceiro.valorDescontoIni == null || parceiro.valorDescontoIni == 0">
                        Desconto: {{ f2dec(parceiro.valorDesconto) }} %
                    </div>
                    <div class="card-text telefone mt-2  mb-3fw-bold" title="Telefone">Telefone: {{ parceiro.telefone }}
                    </div>
                    <div class="text-center mt-2">
                        <RouterLink :to="{ name: 'PainelClienteParceiro', params: { parceiroId: parceiro.parceiroId } }"
                            class="btn btn-primary btn-sm text-center">Ver detalhes</RouterLink>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="controle.parceiros.length == 0">
            <div class="col-md-12">
                Nenhum parceiro encontrado.
            </div>
        </div>
    </div>

    <MsgBox :id="'janSair'" :titulo="'Atenção'" :exibir="controle.janSair" @onFechou="controle.janSair = false"
        :botao-sim="true" :botao-nao="true" @onSim="sair()">
        <div class="row">
            <div class="col-md-12 fw-bold fs-5">
                Deseja realmente sair?
            </div>
        </div>
    </MsgBox>

</template>


<style lang="css" scoped>
.botao-menu {
    background-color: white;
    border-radius: 10px;
    padding: 15px;
    height: 150px;
    font-size: 16px;
    text-align: center;
    color: black;
    font-style: normal;
    margin-bottom: 15px;
    text-decoration: none;
    display: block;
    cursor: pointer;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .12);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.botao-menu:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(56, 65, 74, 0.12);
}

.botao-menu>.titulo {
    min-height: 48px;
    line-height: 20px;
}

.botao-menu i {
    font-size: 40px;
    margin-top: 10px;
    display: block;
}

.img-logo {
    max-width: 300px;
}

.card-title {
    height: 40px;
}

.endereco {
    height: 40px;
}

.card {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .12);
}

.card-img,
.card-img-top,
.card-img-bottom {
    width: 100%;
    min-height: 180px;
    max-height: 180px;
}
</style>
